/**
 * Tier-1 widget vocabulary as this build renders it (spec-widget-mcp 05; D-W1, D-W10, D-W26).
 * Pure constants — `configs/widgetProtocol.js` reads `RENDERED_WIDGET_KINDS` for the `x-widget-kinds`
 * handshake, so this file must never import React.
 */

/** The only tier Phase A renders; `app` (MCP Apps, Tier 2) falls back to `fallbackText`. */
export const NATIVE_TIER = "native";

/** The only payload version this build understands; anything else falls back (D-W10). */
export const NATIVE_PAYLOAD_VERSION = 1;

/**
 * Exactly the kinds this build renders — advertised on the history bootstrap as `x-widget-kinds`
 * (WM03/WM04: chat relays, and completion composes, only a kind the client lists).
 * `WidgetRenderer.test.jsx` proves each one mounts a component.
 */
export const RENDERED_WIDGET_KINDS = Object.freeze([
	"question",
	"data_collection",
	"slot_picker",
	"confirmation",
	"summary",
	"progress",
]);

/** `reply.widget.state` — one-way: shown → submitted, or shown → expired (WM04). */
export const WIDGET_STATE = Object.freeze({ SHOWN: "shown", SUBMITTED: "submitted", EXPIRED: "expired" });

/** The refusal codes chat sends on `record_update_stream.widgetSubmit` (WM04). */
export const WIDGET_SUBMIT_CODE = Object.freeze({
	INVALID: "WIDGET_SUBMIT_INVALID",
	ALREADY_SUBMITTED: "WIDGET_ALREADY_SUBMITTED",
	RECORD_GONE: "WIDGET_RECORD_GONE",
});

/** The field key chat uses for a whole-object fault in `widgetSubmit.fields` (WM04). */
export const FORM_ERROR_KEY = "_form";

/** The local value of a `question` widget's Other option — replaced by the typed text, never sent (D-W15). */
export const OTHER_SENTINEL = "__other__";

/** The slot id a `slot_picker` submits for "none of these" (§7). */
export const NO_SLOT = "none";
